export default "__VITE_ASSET__fc28e413__"